import { render } from "./credit-note-creation.vue?vue&type=template&id=454050c8"
import script from "./credit-note-creation.vue?vue&type=script&lang=js"
export * from "./credit-note-creation.vue?vue&type=script&lang=js"

import "./credit-note-creation.vue?vue&type=style&index=0&id=454050c8&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__